import React from "react";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  disagreeText: {
    color: theme.palette.primary.main,
  },
}));

interface AgreementDialogProps {
  open: boolean;
  setAgreed: (open: boolean) => void;
}
const AgreementDialog: React.FC<AgreementDialogProps> = (
  props: AgreementDialogProps
) => {
  const { open, setAgreed } = props;
  const [disagree, setDisagree] = React.useState(false);
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Welcome to the Vital Teams survey!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p>
            This should take less than 10 minutes, and is completely anonymous.
            By clicking “AGREE” you acknowledge that you have read and accept
            the
            {/* <Link to="/info/terms-of-use" target="_blank">
              {" "}
              Terms of Use
            </Link>{" "}
            and{" "}
            <Link to="/info/privacy-policy" target="_blank">
              Privacy Policy
            </Link> */}
            <a
              href="https://storage.googleapis.com/vital-teams-static/documents/terms-of-use.pdf"
              target="_blank"
            >
              {" "}
              Terms of Use
            </a>{" "}
            and{" "}
            <a
              href="https://storage.googleapis.com/vital-teams-static/documents/privacy-policy.pdf"
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
          {disagree && (
            <strong className={classes.disagreeText}>
              You must agree to the Terms of Use and Privacy Policy before
              taking part in the Vital Teams survey. If you have any concerns
              please feel free to contact us at{" "}
              <a href="mailto:support@vitalteams.com">support@vitalteams.com</a>
            </strong>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => setDisagree(true)}
        >
          Disagree
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setAgreed(true)}
        >
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgreementDialog;
